import React, { useContext, useEffect, useState } from 'react';
import { AppBar, Hidden } from '@mui/material';
import { withStyles } from '@mui/styles';
import { useFlags } from 'launchdarkly-react-client-sdk';
import DesktopNavigation from '../../components/HeaderComponents/DesktopNavigation/DesktopNavigation';
import MobileNavbar from '../../components/HeaderComponents/MobileNavbar/MobileNavbar';
import { AdminAuthContext } from '../Contexts/AdminAuthContext';
import { COLORS } from '../../utils/Application_Constants';
import { checkFeatureFlag } from '../../components/GlobalComponents/FeatureFlagComponent/FeatureFlag';

const styles = (theme) => ({
    root: {
        background: `${COLORS.WHITE} 0% 0% no-repeat padding-box`,
        borderRadius: 3,
        boxShadow: `0px 3px 12px ${COLORS.BLACK}D`,
        color: COLORS.BLACK,
        height: '60px',
        zIndex: 1300,
        [theme.breakpoints.up('md')]: {
            height: '80px',
        },
    },
    filler: {
        height: '80px',
        [theme.breakpoints.down('sm')]: {
            height: '60px',
        },
    },
    progressWrapper: {
        height: '80vh',
    },
    progressRoot: {
        marginTop: '25vh',
    },
});

const timesheetLink = {
    name: 'Timesheet Management',
    isParentClickable: true,
    parentUrlLink: '/timesheets',
    children: [],
    id: 1,
};

const expenseLink = {
    name: 'Expense Management',
    isParentClickable: true,
    parentUrlLink: '/expenses',
    children: [],
    id: 2,
};

const creditCardLink = {
    name: 'Credit Card Management',
    isParentClickable: true,
    parentUrlLink: '/credit-cards',
    children: [],
    id: 3,
};

const processedTimesheetsLink = {
    name: 'Processed Timesheets',
    isParentClickable: false,
    parentUrlLink: '/processed-timesheets',
    children: [
        { link: '/processed-timesheets', name: 'All Processed Timesheets', id: 5 },
        { link: '/processed-timesheets/bill-pay', name: 'Bill Pay View', id: 6 },
        {
            link: '/processed-timesheets/team-coordinator',
            name: 'Team Coordinator View',
            id: 7,
        },
        {
            link: process.env.REACT_APP_PROCESSED_TIMESHEETS_POWER_BI,
            externalUrl: true,
            name: 'Power BI',
            id: 8,
        },
    ],
    id: 4,
};

const invoicingLinks = {
    name: 'Invoicing',
    isParentClickable: false,
    parentUrlLink: '/invoicing',
    children: [
        { link: '/invoicing/initiation', name: 'Invoicing Initiation', id: 10 },
        { link: '/invoicing/invoice-management', name: 'Invoice Management', id: 11 },
    ],
    id: 9,
};

const AdminNavbar = (props) => {
    const { classes } = props;
    const [navigation, setNavigation] = useState([]);
    const [isNCREFFEnabled, setIsNCREFFEnabled] = useState(false); // Non-Clinician Reimbursement Expense Feature Flag check
    const {
        isTimesheetUser,
        isExpenseUser,
        isTimesheetSystemAdminUser,
        isExpenseSystemAdministratorUser,
        isLTAssociateUser,
        isInvoicingUser,
        isAuthenticated,
        accessDenied,
    } = useContext(AdminAuthContext);
    const flags = useFlags();

    useEffect(() => {
        checkFeatureFlag('NonClinicianReimbursementExpenseFeatures', false)
            .then((flagValue) => {
                setIsNCREFFEnabled(flagValue);
            })
            .catch((error) => console.error(error));
    }, []);

    useEffect(() => {
        const {
            ltoeWebProcessedtimesheetsEnableNavigation,
            ltoeWebExpensesEnableCreditCardList,
            ltoeWebInvoicingEnableNavigation,
        } = flags;

        let links = [];
        if (isTimesheetUser) links = [...links, timesheetLink];
        if (ltoeWebProcessedtimesheetsEnableNavigation) {
            if (isTimesheetUser || isTimesheetSystemAdminUser || isLTAssociateUser) {
                links = [...links, processedTimesheetsLink];
            }
        }
        if (isExpenseUser) links = [...links, expenseLink];
        if (
            isExpenseSystemAdministratorUser &&
            isNCREFFEnabled &&
            ltoeWebExpensesEnableCreditCardList
        ) {
            links = [...links, creditCardLink];
        }
        if (ltoeWebInvoicingEnableNavigation && isInvoicingUser) {
            links = [...links, invoicingLinks];
        }
        setNavigation(links);
    }, [isAuthenticated, accessDenied, isExpenseUser, isTimesheetUser, isInvoicingUser, flags]);

    return (
        <>
            <AppBar className={classes.root}>
                <Hidden mdUp>
                    <MobileNavbar
                        menuNavigation={isAuthenticated && !accessDenied ? navigation : []}
                    />
                </Hidden>
                <Hidden mdDown>
                    <DesktopNavigation
                        menuNavigation={isAuthenticated && !accessDenied ? navigation : []}
                    />
                </Hidden>
            </AppBar>
            <div className={classes.filler} />
        </>
    );
};

export default withStyles(styles)(AdminNavbar);
